class Elements
{
    build(element, text = '', cls = [], attrs = {}){
		const e = document.createElement(element);
		this.setClass(e, cls)
		this.setAttrs(e, attrs)
		this.setText(e, text)
		return e;
	}

	setClass(element, cls){
		if(cls.length > 0){
			element.classList.add(...cls)
		}
	}

	setAttrs(element, attrs){
		for(let attr in attrs || {}){
			element.setAttribute(attr, attrs[attr]);
		}
	}

	setText(element, text){
		if(text !== null && text.length){
			element.textContent = text
		}
	}

	add(element, appends = []){
		appends.forEach(ap => {
			element.appendChild(ap)
		})
	}

	empty(element){
		while(element.firstChild){
			element.removeChild(element.firstChild)
		}
	}
}

export default new Elements()